<template>
	<div>
		<div class="new-r">
			<div class="new-title show-one-lines" v-text="param.title"></div>
			<div class="new-r-img">
				<template v-if="param.open_type == 'url'">
					<a :href="param.page_url" target="_blank" class="hot-img"><img :src="param.pic_url" alt /></a>
				</template>
				<template v-else>
					<router-link :to="param.page_url" class="hot-img"><img :src="param.pic_url" alt /></router-link>
				</template>
			</div>
			<div class="new-r-list">
				<div class="new-r-item" v-for="(item,index) in param.list[0].goods_list" :key="index">
					<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank" class="clearfloat">
						<img :src="item.pic_url" alt />
						<div class="pic">
							<div class="picname" v-text="item.name"></div>
							<div v-text="'¥'+item.price"></div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			},
		},
		data() {
			return {
				
			};
		}
	};
</script>

<style lang="scss" scoped>
	.new-r {
		width: 390px;
		margin-top: 20px;
		height: 417px;
		background-color: #fff;
		padding: 0 20px 20px 20px;
		box-sizing: border-box;

		.new-title {
			line-height: 56px;
			height: 56px;
			font-size: 18px;
			font-weight: 600;
		}

		.new-r-img {
			width: 347px;
			height: 167px;
			overflow: hidden;

			a {
				display: block;
			}

			img {
				width: 347px;
				height: 167px;
				transition: 0.5s;
				-moz-transition: 0.5s;
				-webkit-transition: 0.5s;
				-o-transition: 0.5s;
			}

			&:hover img {
				-webkit-transform: scale(1.2);
				-moz-transform: scale(1.2);
				-o-transform: scale(1.2);
				-ms-transform: scale(1.2);
				transform: scale(1.2);
			}
		}

		.new-r-list {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			padding-top: 4px;
			box-sizing: border-box;

			.new-r-item {
				// width: 50%;
				display: flex;
				margin-top: 16px;
				transition: .5s;
				-moz-transition: .5s;
				-webkit-transition: .5s;
				-o-transition: .5s;

				a {
					display: flex;

					img {
						float: left;
						height: 69px;
						width: 69px;
					}

					.pic {
						float: left;
						width: 76px;
						margin-left: 16px;

						:first-child {
							width: 100%;
							height: 36px;
							line-height: 18px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;
						}

						:last-child {
							font-size: 16px;
							color: #ff0e25;
							margin-top: 12px;
						}
					}

					&:hover .picname {
						color: #ff0e25;
					}
				}

				&:hover {
					opacity: 0.8;
				}


			}
		}
	}
</style>
